import React, { createContext, useContext, useState, useEffect } from 'react';
import tr from '../translations/tr';
import en from '../translations/en';

const LanguageContext = createContext();

const translations = { tr, en };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('bms-language');
    return saved || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('bms-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  const switchLanguage = (lang) => {
    if (lang === 'tr' || lang === 'en') {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
